import { Library, Users, BookOpen, ClipboardList, FileText, PieChart, Filter, Shield, Layers, MessageSquare, Building2 } from 'lucide-react';

import Sidebar from '../../../components/ui/SideBar';

export default function AdminSidebar({ children }) {

  const sidebarLinks = [
    {
      isSection: true,
      title: 'Overview',
    },
    {
      title: 'Analytics',
      icon: <PieChart className="w-5 h-5" />,
      href: '/admin/analytics',
    },
    {
      isSection: true,
      title: 'Management',
    },
    {
      title: 'User Management',
      icon: <Users className="w-5 h-5" />,
      href: '/admin/users'
    },
    {
      title: 'Academics',
      icon: <Filter className="w-5 h-5" />,
      subLinks: [
        { title: 'University', href: '/admin/university' },
        { title: 'Faculty', href: '/admin/faculty' },
        { title: 'Department', href: '/admin/department' },
      ]
    },
    {
      title: 'Course Management',
      icon: <Library className="w-5 h-5" />,
      href: '/admin/courses',
    },
    {
      title: 'Topic Management',
      icon: <Library className="w-5 h-5" />,
      href: '/admin/topics',
    },
    {
      isSection: true,
      title: 'Assessment',
    },
    {
      title: 'Quiz Management',
      icon: <ClipboardList className="w-5 h-5" />,
      href: '/admin/quizzes'
    },
    {
      title: 'Question Bank',
      icon: <BookOpen className="w-5 h-5" />,
      href: '/admin/question-bank'
    },
    {
      title: 'Quiz Feedback',
      icon: <MessageSquare className="w-5 h-5" />,
      href: '/admin/quiz-feedback'
    },
    {
      title: 'Export Course Results',
      icon: <FileText className="w-5 h-5" />,
      href: '/admin/courses/export-results'
    },
    {
      isSection: true,
      title: 'System',
    },
    {
      title: 'Plan & Features',
      icon: <Layers className="w-5 h-5" />,
      href: '/admin/plan-features'
    },
    {
      title: 'Enterprise Applications',
      icon: <Building2 className="w-5 h-5" />,
      href: '/admin/enterprise-applications'
    },
    {
      title: 'Security',
      icon: <Shield className="w-5 h-5" />,
      href: '/admin/security'
    },
  ];

  return (
    <Sidebar sidebarLinks={sidebarLinks}>
      {children}
    </Sidebar>
  )
}
